import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=2cc46578&scoped=true&"
var script = {}
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=2cc46578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc46578",
  null
  
)

export default component.exports